import { render, staticRenderFns } from "./DContentOutsideLinkPreview.vue?vue&type=template&id=1c0ed2b9&"
import script from "./DContentOutsideLinkPreview.vue?vue&type=script&lang=js&"
export * from "./DContentOutsideLinkPreview.vue?vue&type=script&lang=js&"
import style0 from "./DContentOutsideLinkPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports